document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-bundle-section]').forEach(initBundleSection);
});

// Minimal formatter for Shopify's money_format string (e.g. "${{amount}}", "Rs.{{amount}}").
// Supports the four standard placeholders; falls back to a plain 2-decimal string if the
// format string is missing or uses a placeholder we don't recognize.
function bundleFormatMoney(cents, format) {
  const amount = (cents / 100).toFixed(2);
  const noDecimals = Math.round(cents / 100).toString();
  const withComma = amount.replace(/\B(?=(\d{3})+(?!\d)(?=\.))/g, ',');
  const noDecimalsWithComma = noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  if (!format) return `Rs.${amount}`;

  return format
    .replace(/{{\s*amount\s*}}/, amount)
    .replace(/{{\s*amount_no_decimals\s*}}/, noDecimals)
    .replace(/{{\s*amount_with_comma_separator\s*}}/, withComma)
    .replace(/{{\s*amount_no_decimals_with_comma_separator\s*}}/, noDecimalsWithComma);
}

function initBundleSection(section) {
  const bundleQty = parseInt(section.dataset.bundleQty, 10) || 3;
  const moneyFormat = section.dataset.moneyFormat || '';
  const cards = Array.from(section.querySelectorAll('[data-bundle-item]'));
  const progressWrap = section.querySelector('[data-bundle-progress]');
  const progressFill = section.querySelector('[data-bundle-progress-fill]');
  const progressText = section.querySelector('[data-bundle-progress-text]');
  const bannerText = section.querySelector('[data-bundle-banner-text]');
  const addAllBtn = section.querySelector('[data-bundle-add-all]');

  if (!addAllBtn || !cards.length) {
    console.warn('[bundle-deals] Section is missing required elements, skipping init.', section);
    return;
  }

  // Only the first "bundle quantity" cards start selected, matching the
  // advertised bundle size — not every product in the section.
  cards.slice(0, bundleQty).forEach((card) => card.classList.add('is-selected'));

  function getSelected() {
    return cards.filter((card) => card.classList.contains('is-selected'));
  }

  function updateProgress() {
    const selected = getSelected();
    const count = selected.length;

    if (progressWrap) progressWrap.hidden = false;
    if (progressFill) {
      const pct = Math.min(100, Math.round((count / bundleQty) * 100));
      progressFill.style.width = pct + '%';
    }

    if (progressText) {
      if (count >= bundleQty) {
        progressText.textContent = `Bundle unlocked! ${count} item${count > 1 ? 's' : ''} selected.`;
      } else {
        const remaining = bundleQty - count;
        progressText.textContent = `Add ${remaining} more item${remaining > 1 ? 's' : ''} to unlock the bundle price.`;
      }
    }

    if (bannerText) {
      if (count > 0) {
        const totalCents = selected.reduce((sum, card) => sum + (parseInt(card.dataset.price, 10) || 0), 0);
        const formatted = bundleFormatMoney(totalCents, moneyFormat);
        bannerText.innerHTML = `${count} item${count > 1 ? 's' : ''} selected — <strong>${formatted}</strong>`;
      } else {
        bannerText.textContent = 'Select items to build your bundle';
      }
    }

    addAllBtn.disabled = count === 0;
  }

  function toggleCard(card) {
    card.classList.toggle('is-selected');
    updateProgress();
  }

  cards.forEach((card) => {
    // Dedicated handler for the round "+" select icon — stops the click from
    // also bubbling to the card handler below, so it only toggles once.
    const selectBtn = card.querySelector('[data-bundle-select-btn]');
    if (selectBtn) {
      selectBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleCard(card);
      });
    }

    // Clicking anywhere else on the card (except the title link) also toggles it.
    card.addEventListener('click', (e) => {
      if (e.target.closest('a')) return;
      if (e.target.closest('[data-bundle-select-btn]')) return;
      toggleCard(card);
    });
  });

  addAllBtn.addEventListener('click', async () => {
    const selected = getSelected();
    if (!selected.length) return;

    const items = selected
      .map((card) => ({
        id: parseInt(card.dataset.variantId, 10),
        quantity: 1,
      }))
      .filter((item) => item.id);

    if (!items.length) return;

    addAllBtn.disabled = true;
    const originalLabel = addAllBtn.textContent;
    addAllBtn.textContent = 'Adding...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      const result = await response.json();

      if (!response.ok) {
        console.error('[bundle-deals] Cart add failed:', result);
        throw new Error(result.message || result.description || 'Cart add failed');
      }

      // Let the rest of the theme know the cart changed so its drawer/badge can refresh.
      // Horizon (and most Dawn-based themes) listen for this custom event name;
      // if your theme's cart drawer doesn't update, replace this with whatever
      // element/method your cart-drawer component exposes (check its .js file).
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

      const cartDrawer = document.querySelector('cart-drawer, cart-notification');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        const cart = await (await fetch('/cart.js')).json();
        cartDrawer.renderContents(cart);
      } else {
        console.warn('[bundle-deals] No cart-drawer/cart-notification element found on this page. Items were added to cart — redirecting to /cart. Tell your developer to check the theme\'s actual cart drawer element name.');
        window.location.href = '/cart';
        return;
      }

      addAllBtn.textContent = 'Added!';
      setTimeout(() => {
        addAllBtn.textContent = originalLabel;
        addAllBtn.disabled = false;
      }, 1500);
    } catch (err) {
      console.error('[bundle-deals] Add to cart error:', err);
      addAllBtn.textContent = 'Something went wrong';
      setTimeout(() => {
        addAllBtn.textContent = originalLabel;
        addAllBtn.disabled = false;
      }, 1500);
    }
  });

  updateProgress();
}